import { useConnectorId } from "../../navigation/connectors";
import { connectorsApi } from "../../services/api/connectors";
import FileListTabPage from "../files/FileListTabPage";

export default function ConnectorFilesTabPage() {
    return <FileListTabPage api={connectorsApi.files} ownerId={useConnectorId()} />;
}
